import PreviewImages from '@/common/components/adjusterReport/previewImages/PreviewImages';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import RepeatCapturingModal from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/vehicleDamageImagePreview/RepeatCapturingModal';
import {
  INITIAL_ADJUSTER_IMAGES_LINKS,
  INITIAL_VISIT_ADJUSTER_IMAGES_LINKS,
} from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import { getDamagedAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQueryOptions';
import { useRemoveDamagedPartsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/removeDamagedParts/removeDamagedPartsQueryOptions';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default function InitialVisitServerImagePreviewPage() {
  return (
    <MainLayout title=" بازدید اولیه / تصاویر" header="titleHeader">
      <InitialVisitServerImagePreview />
    </MainLayout>
  );
}

const InitialVisitServerImagePreview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { closeModal, open, openModal } = useModal();
  const { resetCameraStore } = useImageFlowStore();
  const { resetDamagedPoints } = useDamagedPoints();
  const { data: vehicleImages } = useQuery(
    getDamagedAdjusterImagesQueryOptions({
      id: +id!,
      enable: true,
      participantRoleType: 'initial',
    }),
  );
  const { getCurrentFileOfflineImages, deleteOfflineFileData } =
    useGetOfflineImages();

  const addDamagedPoints = () => {
    navigate(
      INITIAL_VISIT_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_SERVER_DAMAGED_POINTS(
        id!,
      ),
    );
  };
  const retakePhotoModal = () => {
    openModal();
  };
  const confirmRetakePhoto = async () => {
    const file = await getCurrentFileOfflineImages({});
    if (file.hasOffline && file.offlineItem?.id) {
      deleteOfflineFileData(file.offlineItem?.id);
    }
    openModal();
    resetDamagedPoints();
    resetCameraStore();
    navigate(
      INITIAL_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_VEHICLE_IMAGES.edit(id!),
    );
  };

  const { mutateAsync: deleteImage } = useRemoveDamagedPartsQueryOptions();

  const handleDeleteDamagePointImage = (image_id: number) => {
    deleteImage({ image_id, id: +id!, type: 'initial' });
    closeModal();
    queryClient.invalidateQueries({
      queryKey: getDamagedAdjusterImagesQueryOptions({
        id: +id!,
        enable: true,
        participantRoleType: 'initial',
      }).queryKey,
    });
  };

  return (
    <Box pt={24}>
      <PreviewImages
        userType="initial"
        addDamagePoint={addDamagedPoints}
        retakeImage={retakePhotoModal}
        handleDeleteImage={handleDeleteDamagePointImage}
        images={{
          damagedImages:
            vehicleImages?.damaged_parts.map((item) => ({
              name: item.label,
              src: item.url,
              id: item.id,
              type: 'initial',
            })) ?? [],
          vehicleImages:
            vehicleImages?.vehicle.map((item) => ({
              name: item.label,
              src: item.url,
            })) ?? [],
        }}
      />
      <RepeatCapturingModal
        closeModal={closeModal}
        repeatCapturing={confirmRetakePhoto}
        open={open}
      />
    </Box>
  );
};
